import { render, staticRenderFns } from "./appoint.vue?vue&type=template&id=6665398c"
import script from "./appoint.vue?vue&type=script&lang=tsx"
export * from "./appoint.vue?vue&type=script&lang=tsx"
import style0 from "./appoint.vue?vue&type=style&index=0&id=6665398c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports